import { formatDate } from "@/core/helpers/DatetimeConverter";

const PointsMap = {
  Plural: "Points",
  Single: "Point",
  ModalForm: false,
  DefaultSorting: "pointsAddedDate",
  DefaultSortingType: "desc",
  Columns: [
    { name: "", label: "#", type: "counter" },
    {
      name: "nickName",
      dbName: "user.nickName",
      label: "User",
      type: "text",
      format: (row: any) => row.user?.nickName ?? "—",
    },
    {
      name: "points",
      dbName: "points",
      label: "Points",
      type: "text",
    },
    {
      name: "reason",
      dbName: "reason",
      label: "Reason",
      type: "text",
    },
    {
      name: "pointsAddedDate",
      dbName: "pointsAddedDate",
      label: "Points Added",
      sortable: true,
      type: "date",
      format: (row: any) => formatDate(row.pointsAddedDate),
    },
  ],
  PrimaryKey: "id",
  Actions: {}, // read-only list
};

export default PointsMap;
